// Maps the DICE "onboardingAnswers" experience blob to the guest profile fields the
// kiosk experiences consume (via getLoginPayload -> nonstandardUser).
//
// Under DICE (see the diceCenterSessions flag in centerHooks), a guest's identity is not
// echoed back on the session lookup; it lives in the experience blob written via
// PUT /experience — by the onboarding flow, or by the legacy login form's session mint
// (useGetCode). The kiosk lookup (useGetUserFromCode) rebuilds the profile from that
// blob when a code resolves to a guest session.

// The onboarding country step's answer as one country: residence first, then birth country.
export const getOnboardingAnswersCountry = (onboardingAnswers) =>
  onboardingAnswers?.['current-country']?.[0] ?? onboardingAnswers?.['birth-country']?.[0]

// onboardingAnswers -> the guest profile fields getLoginPayload reads, plus Content Country.
export const onboardingAnswersToGuestProfile = (onboardingAnswers) => {
  const answers = onboardingAnswers ?? {}
  return {
    givenName: answers['first-name']?.[0],
    familyName: answers['last-name']?.[0],
    birthYear: answers['birth-year']?.[0],
    email: answers.email?.[0],
    onboardingCountry: getOnboardingAnswersCountry(answers),
  }
}

// The inverse mapping: legacy login form fields -> onboardingAnswers. The unauth login
// form (UnauthSigninForm) submits the last name as `surname`, so read that; `familyName`
// is accepted too for callers that already use the getLoginPayload shape. Blank fields are
// omitted rather than written as empty answers, so they never mask saved values.
export const guestProfileToOnboardingAnswers = (guestProfile) => {
  const { givenName, familyName, surname, birthYear, email } = guestProfile ?? {}
  const lastName = familyName ?? surname
  const answers = {}
  if (givenName) answers['first-name'] = [givenName]
  if (lastName) answers['last-name'] = [lastName]
  if (birthYear) answers['birth-year'] = [String(birthYear)]
  if (email) answers.email = [email]
  return answers
}

// GET /experience envelope is { data: { onboardingAnswers }|{ visitorData }, completed }.
// Tolerate the older visitorData key (mirrors Onboarding's useGetExperience).
export const extractOnboardingAnswers = (experienceResponse) => {
  const envelope = experienceResponse?.data?.data
  return envelope?.onboardingAnswers ?? envelope?.visitorData ?? {}
}
